import { lockBody, unlockBody, SetVhElement } from "@plugins";

window.addEventListener("load", () => {
    if (window.mobileMedia) {
        mobileSearch();
    } else {
        pcSearch();
    }
});

function mobileSearch() {
    const headerMob = document.querySelector(".js-header-mob");

    if (headerMob) {
        const searchWindow = headerMob.querySelector(".js-header-search");

        addListeners(headerMob);

        new SetVhElement(searchWindow);
    }
}

function pcSearch() {
    const header = document.querySelector(".js-header");

    if (header) {
        const searchWindow = header.querySelector(".js-header-search");

        addListeners(header);

        new SetVhElement(searchWindow);

        document.addEventListener("keyup", (e) => {
            if (e.key === "Escape" && searchWindow.classList.contains("active")) {
                toggleModal(searchWindow);
            }
        });
    }
}

function addListeners(el) {
    const searchActivate = el.querySelector(".js-open-search");
    const searchClose = el.querySelector(".js-close-search");

    if (searchActivate) {
        searchActivate.addEventListener("click", () => {
            toggleModal(el);
        });
    }

    if (searchClose) {
        searchClose.addEventListener("click", () => {
            toggleModal(el);
        });
    }
}

function toggleModal(el) {
    const searchWindow = el.querySelector(".js-header-search");

    if (!searchWindow) return;

    if (!searchWindow.classList.contains("active")) {
        searchWindow.classList.add("active");

        if (window.mobileMedia) {
            const headerHamburger = el.querySelector(".js-header-hamburger");
            const headerDropDownContainer = el.querySelector(".js-header-hamburger-target");

            el.classList.add("search-opened");

            if (headerDropDownContainer.classList.contains("active")) {
                headerDropDownContainer.classList.remove("active");
                headerHamburger.classList.remove("is-active");
                unlockBody();
            }
        }

        lockBody(searchWindow, { reserveScrollBarGap: true });
    } else {
        searchWindow.classList.remove("active");

        if (window.mobileMedia) {
            el.classList.remove("search-opened");
        }

        unlockBody();
    }
}
